// External imports
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Styles
import "./App.css";

// Page components
import AboutPlanetrus from "./pages/AboutPlanetrus";
import ContactUs from "./pages/ContactUs";
import Home from "./pages/Home";
import OurCommitments from "./pages/OurCommitments";
import PageNotFound from "./pages/PageNotFound";
import TheCircularEconomy from "./pages/TheCircularEconomy";
import UsedCookingOilRecycling from "./pages/UsedCookingOilRecycling";
import WhyUs from "./pages/WhyUs";
import BlogDetail from "./pages/BlogDetail";

// Layout components
import RouteLayout from "./layouts/RouteLayout";
import MeetOurTeam from "./pages/MeetOurTeam";
import Blog from "./pages/Blog";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const updateDocumentDirection = (lang: string) => {
      const direction = lang === "ar" ? "rtl" : "ltr";
      document.documentElement.setAttribute("dir", direction);
      document.documentElement.setAttribute("lang", lang);
      document.body.setAttribute("dir", direction);
    };

    updateDocumentDirection(i18n.language);
    i18n.on("languageChanged", updateDocumentDirection);

    return () => {
      i18n.off("languageChanged", updateDocumentDirection);
    };
  }, [i18n]);

  return (
    <>
      <Routes>
        <Route element={<RouteLayout />}>
          <Route path="/*">
            <Route index element={<Home />} />
            <Route path="sustainability/used-cooking-oil-recycling" element={<UsedCookingOilRecycling />} />
            <Route path="sustainability/the-circular-economy" element={<TheCircularEconomy />} />
            <Route path="about-us">
              <Route path="about-planetrus" element={<AboutPlanetrus />} />
              <Route path="meet-our-team" element={<MeetOurTeam />} />
            </Route>
            <Route path="why-us" element={<WhyUs />} />
            <Route path="our-commitments" element={<OurCommitments />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="blog">
              <Route index element={<Blog />} />
              <Route path=":id" element={<BlogDetail />} />
            </Route>
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
